import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartLine,
  faCloudArrowUp,
  faCode,
  faMobileScreenButton
} from '@fortawesome/free-solid-svg-icons';
import './About.css';

const servicePillars = [
  {
    name: 'Custom Web Development',
    icon: faCode,
    description:
      'Scalable, secure web applications tailored to your operations, customers, and growth plans.'
  },
  {
    name: 'Mobile App Development',
    icon: faMobileScreenButton,
    description:
      'User-centred iOS and Android experiences built for engagement, retention, and reliability.'
  },
  {
    name: 'Cloud, DevOps & Automation',
    icon: faCloudArrowUp,
    description:
      'Modern infrastructure, release workflows, and automation that keep delivery fast and dependable.'
  },
  {
    name: 'Digital Strategy & Consulting',
    icon: faChartLine,
    description:
      'Roadmaps grounded in commercial goals, customer insight, and practical execution.'
  }
];

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <motion.div
          className="section-title about-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="about-eyebrow">What we deliver</p>
          <h2>Solutions built to move your business forward.</h2>
          <p>
            We combine engineering, design, and operational thinking to build digital products
            that launch cleanly and scale without friction.
          </p>
        </motion.div>

        <div className="services-grid">
          {servicePillars.map((service, index) => (
            <motion.div
              key={service.name}
              className="service-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
            >
              <div className="service-icon">
                <FontAwesomeIcon icon={service.icon} />
              </div>
              <h3>{service.name}</h3>
              <p>{service.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="about-footer"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <p>
            Need strategy, delivery, and ongoing optimisation under one team? That is where we work best.
          </p>
          <Link to="/contact" className="btn primary-btn">Request a Consultation</Link>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
